var React = require('react');

function CameraInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M29.9,19.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S30.7,19.4,29.9,19.4z M17.2,15.7\n\t\tc-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,1.2-0.5,2.3-1.3,3.2C19.5,15.2,18.4,15.7,17.2,15.7z M4.5,6\n\t\tC3.7,6,3,5.3,3,4.5S3.7,3,4.5,3C5.3,3,6,3.7,6,4.5S5.3,6,4.5,6z M32.9,0H1.5C0.7,0,0,0.7,0,1.5v19.4c0,0.8,0.7,1.5,1.5,1.5h31.4\n\t\tc0.8,0,1.5-0.7,1.5-1.5V1.5C34.4,0.7,33.7,0,32.9,0z"}))]);
}

CameraInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 34.4 22.4","style":{"enableBackground":"new 0 0 34.4 22.4"},"xmlSpace":"preserve"};

module.exports = CameraInline;

CameraInline.default = CameraInline;
